import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ProjectDetails } from '@/app/interfaces/project';
import { ReviewFieldsService } from '@/app/services/ia-services/review-fields.service';
import { ReviewFieldKey } from '@/app/interfaces/review-fields.types';
import { TooltipComponent } from '@/app/shared/tooltip/tooltip.component';
import { EconomicAmountPipe } from '@/app/pipe/economicAmount.pipe';

@Component({
  selector: 'app-project-economic-data',
  standalone: true,
  imports: [CommonModule, TooltipComponent, EconomicAmountPipe],
  templateUrl: './project-economic-data.component.html',
})
export class ProjectEconomicDataComponent {
  @Input() project: ProjectDetails | null = null;
  @Input() reviewMode = false;
  @Input() readonlyReview = false;
  @Input() showPreviousReviewIndicators = false;

  constructor(public reviewFields: ReviewFieldsService) {}

  formatValues(values: Array<string | number> | null | undefined): string {
    return values?.length ? values.join(', ') : '-';
  }

  previousReviewText(fieldKey: ReviewFieldKey): string {
    return this.reviewFields.getPreviousReviewTooltipText(fieldKey);
  }
}
